export default __webpack_public_path__ + "static/media/gloss_b.3645edc3.svg";